<script>
    export let errorCode;

    const authErrors = [
        {code: "auth/email-already-in-use", de: "Für diese E-Mail Adresse ist bereits ein Account angelegt."},
        {code: "auth/internal-error", de: "Bei der Anmeldung ist ein Fehler aufgetreten, bitte versuche es später erneut."},
        {code: "auth/invalid-email", de: "Die eingegebene E-Mail-Adresse ist ungültig."},
        {code: "auth/wrong-password", de: "Deine E-Mail oder dein Passwort sind falsch."},
        {code: "auth/weak-password", de: "Das eingegebene Passwort ist zu unsicher, bitte gib ein längeres Passwort ein."},
        {code: "auth/user-not-found", de: "Dieser Nutzer existiert nicht."},
        {code: "auth/requires-recent-login", de: "Dein Login ist zu lange her, bitte logge dich einmal aus und wieder ein."},
        {code: "auth/admin-restricted-operation", de: ""},
        {code: "auth/argument-error", de: ""},
        {code: "auth/app-not-authorized", de: ""},
        {code: "auth/app-not-installed", de: ""},
        {code: "auth/captcha-check-failed", de: ""},
        {code: "auth/code-expired", de: ""},
        {code: "auth/cordova-not-ready", de: ""},
        {code: "auth/cors-unsupported", de: ""},
        {code: "auth/credential-already-in-use", de: ""},
        {code: "auth/custom-token-mismatch", de: ""},
        {code: "auth/dependent-sdk-initialized-before-auth", de: ""},
        {code: "auth/dynamic-link-not-activated", de: ""},
        {code: "auth/email-change-needs-verification", de: ""},
        {code: "auth/emulator-config-failed", de: ""},
        {code: "auth/expired-action-code", de: ""},
        {code: "auth/cancelled-popup-request", de: ""},
        {code: "auth/invalid-api-key", de: ""},
        {code: "auth/invalid-app-credential", de: ""},
        {code: "auth/invalid-app-id", de: ""},
        {code: "auth/invalid-user-token", de: ""},
        {code: "auth/invalid-auth-event", de: ""},
        {code: "auth/invalid-cert-hash", de: ""},
        {code: "auth/invalid-verification-code", de: ""},
        {code: "auth/invalid-continue-uri", de: ""},
        {code: "auth/invalid-cordova-configuration", de: ""},
        {code: "auth/invalid-custom-token", de: ""},
        {code: "auth/invalid-dynamic-link-domain", de: ""},
        {code: "auth/invalid-emulator-scheme", de: ""},
        {code: "auth/invalid-credential", de: ""},
        {code: "auth/invalid-message-payload", de: ""},
        {code: "auth/invalid-multi-factor-session", de: ""},
        {code: "auth/invalid-oauth-client-id", de: ""},
        {code: "auth/invalid-oauth-provider", de: ""},
        {code: "auth/invalid-action-code", de: ""},
        {code: "auth/unauthorized-domain", de: ""},
        {code: "auth/invalid-persistence-type", de: ""},
        {code: "auth/invalid-phone-number", de: ""},
        {code: "auth/invalid-provider-id", de: ""},
        {code: "auth/invalid-recipient-email", de: ""},
        {code: "auth/invalid-sender", de: ""},
        {code: "auth/invalid-verification-id", de: ""},
        {code: "auth/invalid-tenant-id", de: ""},
        {code: "auth/multi-factor-info-not-found", de: ""},
        {code: "auth/multi-factor-auth-required", de: ""},
        {code: "auth/missing-android-pkg-name", de: ""},
        {code: "auth/missing-app-credential", de: ""},
        {code: "auth/auth-domain-config-required", de: ""},
        {code: "auth/missing-verification-code", de: ""},
        {code: "auth/missing-continue-uri", de: ""},
        {code: "auth/missing-iframe-start", de: ""},
        {code: "auth/missing-ios-bundle-id", de: ""},
        {code: "auth/missing-or-invalid-nonce", de: ""},
        {code: "auth/missing-multi-factor-info", de: ""},
        {code: "auth/missing-multi-factor-session", de: ""},
        {code: "auth/missing-phone-number", de: ""},
        {code: "auth/missing-verification-id", de: ""},
        {code: "auth/app-deleted", de: ""},
        {code: "auth/account-exists-with-different-credential", de: ""},
        {code: "auth/network-request-failed", de: ""},
        {code: "auth/null-user", de: ""},
        {code: "auth/no-auth-event", de: ""},
        {code: "auth/no-such-provider", de: ""},
        {code: "auth/operation-not-allowed", de: ""},
        {code: "auth/operation-not-supported-in-this-environment", de: ""},
        {code: "auth/popup-blocked", de: ""},
        {code: "auth/popup-closed-by-user", de: ""},
        {code: "auth/provider-already-linked", de: ""},
        {code: "auth/quota-exceeded", de: ""},
        {code: "auth/redirect-cancelled-by-user", de: ""},
        {code: "auth/redirect-operation-pending", de: ""},
        {code: "auth/rejected-credential", de: ""},
        {code: "auth/second-factor-already-in-use", de: ""},
        {code: "auth/maximum-second-factor-count-exceeded", de: ""},
        {code: "auth/tenant-id-mismatch", de: ""},
        {code: "auth/timeout", de: ""},
        {code: "auth/user-token-expired", de: ""},
        {code: "auth/too-many-requests", de: ""},
        {code: "auth/unauthorized-continue-uri", de: ""},
        {code: "auth/unsupported-first-factor", de: ""},
        {code: "auth/unsupported-persistence-type", de: ""},
        {code: "auth/unsupported-tenant-operation", de: ""},
        {code: "auth/unverified-email", de: ""},
        {code: "auth/user-cancelled", de: ""},
        {code: "auth/user-disabled", de: ""},
        {code: "auth/user-mismatch", de: ""},
        {code: "auth/user-signed-out", de: ""},
        {code: "auth/web-storage-unsupported", de: ""},
        {code: "auth/already-initialized", de: ""},
    ];

    $: errorMessage = authErrors.filter(err => err.code == errorCode)[0]?.de;
</script>

{#if errorCode}
    <br>
    <span class="warning">
        {#if errorMessage}
            {errorMessage}
        {:else}
            Bei der Anmeldung ist ein Fehler aufgetreten, bitte versuche es später erneut.
        {/if}
    </span>
{/if}

<style>
    .warning {
        color: red;
        padding: 0.5rem 1rem;
        border: 1px solid red;
        background-color: #ffdddd;
        border-radius: 0.25rem;
        display: inline-block;
    }
</style>